import React from "react";
import { Row } from "react-bootstrap";
import "./ChoosePub.css";

const ChoosePubImageButton = ({ 
  imgLakay, 
  imgProductLakay, 
  elakayCategoryID, 
  infoSource,
  ButtonPuB1500X400,
  ButtonPuB500X500,
  ButtonPuB400X400
}) => {
  
  const shoosePuB = () => (
    <div className="container">
      <Row xs={1} sm={2} md={3} lg={3} xl={3}>
        
        {/* PUB 1 - 1500x400 Rectangle */}
        <div className="pub-wrapper">
          <button 
            className="pub-image-button pub-button-rectangle"
            onClick={ButtonPuB1500X400}
          >
            {/* Image Background */}
            <div 
              className="pub-bg-image"
              style={{ backgroundImage: `url(${imgLakay})` }}
            ></div>
            
            {/* Overlay */}
            <div className="pub-overlay"></div>
            
            {/* Title */}
            <span className="pub-title">
              {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}
            </span>
          </button>
        </div>

        {/* PUB 2 - 500x500 Square */}
        <div className="pub-wrapper">
          <button 
            className="pub-image-button pub-button-square"
            onClick={ButtonPuB500X500}
          >
            {/* Image Background */}
            <div 
              className="pub-bg-image"
              style={{ backgroundImage: `url(${imgProductLakay})` }}
            ></div>
            
            {/* Overlay */}
            <div className="pub-overlay"></div>
            
            {/* Title */}
            <span className="pub-title">
              {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}
            </span>
          </button>
        </div>

        {/* PUB 3 - 400x400 Circle (conditional) */}
        {elakayCategoryID !== "5ed4946fd2ba8812c20261a8" && (
          <div className="pub-wrapper">
            <button 
              className="pub-image-button pub-button-circle"
              onClick={ButtonPuB400X400}
            >
              {/* Image Background */}
              <div 
                className="pub-bg-image"
                style={{ backgroundImage: `url(${imgProductLakay})` }}
              ></div>
              
              {/* Overlay */}
              <div className="pub-overlay"></div>
              
              {/* Title */}
              <span className="pub-title">
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}
              </span>
            </button>
          </div>
        )}
        
      </Row>
    </div>
  );

  return shoosePuB();
};

export default ChoosePubImageButton;